export const url = 'https://bartendr-api-dev.herokuapp.com';
export * from './urls';
